var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tap-top",style:([_vm.display ? {'display':'block'} : { 'display':'none'} ])},[_c('feather',{attrs:{"type":"chevrons-up"},on:{"click":function($event){return _vm.executeScroll()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }